import { marked } from 'marked';

export const faq = ({ q, a }) => ({
  question: q,
  answer: marked(a),
});
